<template>
  <div class="popup-modal" v-if="visible">
    <div class="popup-content">
      <span class="popup-close" @click="close">&times;</span>
      <div class="login_logo">
        <img src="/ssr/img/tiktok_voice_logo.svg" alt="TikTok AI Voice Generator logo" loading="lazy" height="60px" width="80px" class="top_left_logo"/>
        <img src="/ssr/img/tiktok_voice_word.svg" loading="lazy" title="TikTok AI Voice Generator" alt="TikTok AI Voice Generator logo" height="40px" width="120px" class="top_left_logo"/>
      </div>
      <h2 class="popup-modal-title">{{ data.title }}</h2>
      <ul class="feature-list">
        <li>
          <span class="feature-icon">🎭</span>
          {{ $t('txt2voice.popup_modal_features.voices') }}
        </li>
        <li>
          <span class="feature-icon">🤖</span>
          {{ $t('txt2voice.popup_modal_features.api') }}
        </li>
        <li>
          <span class="feature-icon">⬇️</span>
          {{ $t('txt2voice.popup_modal_features.unlimited') }}
        </li>
      </ul>
      <div class="price-container">
        <div class="price-text">
          <span class="price-prefix">{{ $t('txt2voice.aslow') }} </span>
          <span class="price-amount">$4.99</span>
          <span class="price-original">($12.99)</span>
          <span class="price-period">/{{ $t('pricing.period_month_short') }}</span>
        </div>
      </div>
      <a :href="pricing_href" class="popup-btn" title="TikTok tts pricing">
        {{ $t('txt2voice.popup_download_btn') }}
      </a>
      <div class="save-notice">{{ $t('txt2voice.saved') }}</div>
      <img 
        src="/ssr/img/payicon.webp" 
        alt="Available payment methods"
        loading="lazy"
        fetchpriority="low" 
        width="280px"
        height="40px"
        class="payment-methods-img"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupModal',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: true,
      pricing_href: '/en/pricing'
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close');
    },
    updateLinks(lang) {
      this.pricing_href = `/${lang}/pricing`
    }
  },
  mounted () {
    this.updateLinks(this.$store.state.lang)
  }
}
</script>

<style scoped>
.popup-modal {
  display: flex;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
}

.popup-content {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px 16px;
  width: 85%;
  max-width: 450px;
  margin: auto;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.login_logo {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
}

.popup-modal-title {
  font-size: 20px;
  font-weight: 700;
  margin-top: 5px;
  margin-bottom: 12px;
  color: #333;
  padding: 0 8px;
  line-height: 1.2;
  white-space: normal;
  word-wrap: break-word;
  max-width: 100%;
}

.feature-list {
  list-style: none;
  padding: 3px 10px;
  margin: 10px 0;
  text-align: left;
  background-color: #f9f9f9;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
}

.feature-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-size: 17px;
  color: #444;
  line-height: 1.4;
  padding: 4px 5px;
}

.feature-list li:last-child {
  margin-bottom: 0;
}

.feature-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 28px;
  height: 28px;
  margin-right: 12px;
  font-size: 18px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff6b01, #ff9068);
  color: white;
  padding: 5px;
}

.popup-btn {
  display: block;
  font-size: 20px;
  padding: 12px 0;
  margin: 12px auto;
  border-radius: 30px;
  width: 85%;
  max-width: 350px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: none;
  color: white;
  background: linear-gradient(90deg, #ff7e00, #ff574e, #ff3b69);
  box-shadow: 0 6px 15px rgba(255, 87, 34, 0.25);
  text-decoration: none;
}

.popup-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0));
  transition: left 0.7s ease;
}

.popup-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(255, 87, 34, 0.35);
  text-decoration: none;
  color: white;
}

.popup-btn:hover::before {
  left: 100%;
}

.popup-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(255, 87, 34, 0.2);
}

.popup-btn-badge {
  position: absolute;
  top: -12px;
  right: -20px;
  background: #ff4d4f;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

.payment-methods-img {
  max-width: 320px;
  width: 85%;
  height: auto;
  margin: 8px auto 0;
  display: block;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.payment-methods-img:hover {
  opacity: 1;
}

.popup-close {
  cursor: pointer;
  color: #555;
  font-size: 24px;
  position: absolute;
  top: 15px;
  right: 20px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  background-color: rgba(0, 0, 0, 0.05);
}

.popup-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transform: rotate(90deg);
  color: #000;
}

.price-container {
  margin: 10px auto 8px;
  background-color: transparent;
  border: none;
  border-radius: 12px;
  padding: 0;
  max-width: 400px;
  position: relative;
}

.price-text {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
}

.price-prefix {
  color: #ff6b01;
  font-size: 22px;
  font-weight: 700;
}

.price-amount {
  color: #ff6b01;
  font-size: 28px;
  font-weight: 900;
}

.price-original {
  color: #999;
  font-size: 16px;
  text-decoration: line-through;
}

.price-period {
  color: #666;
  font-size: 16px;
}

.save-notice {
  color: #27ae60;
  font-size: 16px;
  font-weight: 700;
  border: none;
  display: inline-block;
  padding: 2px 10px;
  border-radius: 8px;
  margin: 2px 0 8px;
}

@media (max-width: 600px) {
  .popup-content {
    padding: 16px 14px;
    width: 90%;
    max-width: 350px;
  }
  
  .popup-modal-title {
    font-size: 18px;
    margin-bottom: 10px;
    margin-top: 5px;
    line-height: 1.2;
    padding: 0 5px;
  }
  
  .feature-list {
    margin: 8px 0;
    padding: 2px 8px;
  }
  
  .feature-list li {
    font-size: 16px;
    margin-bottom: 6px;
    padding: 3px 2px;
  }
  
  .popup-btn {
    font-size: 18px;
    padding: 10px 20px;
    margin: 10px auto;
  }
  
  .payment-methods-img {
    max-width: 240px;
    margin: 5px auto 0;
  }
  
  .price-prefix {
    font-size: 18px;
  }

  .price-amount {
    font-size: 24px;
  }

  .price-original {
    font-size: 14px;
  }

  .price-period {
    font-size: 14px;
  }

  .save-notice {
    font-size: 15px;
    padding: 2px 8px;
    margin: 2px 0 6px;
  }
}

@media (max-width: 480px) {
  .popup-modal-title {
    font-size: 17px;
    letter-spacing: -0.3px;
    padding: 0 3px;
    line-height: 1.3;
  }
}

@media (max-width: 380px) {
  .popup-content {
    padding: 14px 10px;
    width: 92%;
  }
  
  .login_logo img {
    height: auto;
  }
  
  .top_left_logo:first-child {
    width: 70px;
  }
  
  .top_left_logo:last-child {
    width: 100px;
  }
  
  .popup-modal-title {
    font-size: 16px;
    letter-spacing: -0.2px;
    padding: 0;
    line-height: 1.3;
  }
  
  .feature-list li {
    font-size: 15px;
  }
  
  .popup-btn {
    font-size: 16px;
    padding: 10px 16px;
  }
  
  .price-prefix {
    font-size: 16px;
  }

  .price-amount {
    font-size: 22px;
  }

  .price-original {
    font-size: 12px;
  }

  .price-period {
    font-size: 12px;
  }

  .save-notice {
    font-size: 14px;
    padding: 2px 8px;
  }
}
</style>
